import { Link } from 'gatsby'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { sizes } from '../helpers/constants'
import { AnimationContext } from '../context/AnimationContext'

const StyledLink = styled(Link)`
  display: flex;
  color: currentColor;
  text-decoration: none;
  &:visited {
    color: currentColor;
    text-decoration: none;
  }
  &:hover,
  &:focus {
    outline: none;
    color: var(--color-primary);
  }
`

const StyledLogo = styled.svg<{ svgFill: string }>`
  transition: width 0.3s linear;
  fill: ${props => props.svgFill || 'currentColor'};
  --size-logo-width: 108px;
  @media all and (min-width: 365px) {
    --size-logo-width: 140px;
  }
  @media all and (min-width: ${sizes.xs}px) {
    --size-logo-width: 180px;
  }
`

export default function Logo({ maxWidth, svgFill }: { maxWidth?: string; svgFill?: string }) {
  const { allowAnimation } = useContext(AnimationContext)
  const strokeWidth = allowAnimation ? 8 : 0
  const pathLength = 1
  const className = allowAnimation ? 'animated-path' : null
  const svgClassName = allowAnimation ? 'logo__svg fill-svg' : 'logo__svg'
  return (
    <div className='logo logo--main' style={{ maxWidth }}>
      <StyledLink to='/' title='Navigate to the homepage.' aria-label='Navigate to the homepage.'>
        <StyledLogo
          className={svgClassName}
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1800 334'
          svgFill={svgFill}
        >
          <g fill={svgFill} clipPath='url(#a)'>
            <path
              d='M569.981 327.356L490.616 198.888V327.356H363.86V1.33226L490.616 1.33154V125.803L571.123 5.32835H718.433L597.958 167.484L721.288 327.356H569.981ZM975.245 3.04447C1012.17 3.04447 1040.91 15.4155 1061.46 40.1576C1082.4 64.8997 1092.87 98.3967 1092.87 140.649V327.356H966.681V156.636C966.681 141.41 962.494 129.419 954.12 120.665C946.126 111.529 935.277 106.961 921.574 106.961C907.49 106.961 896.451 111.529 888.458 120.665C880.464 129.419 876.467 141.41 876.467 156.636V327.356H749.712V5.32835H876.467V54.4319C886.364 39.206 899.497 26.8349 915.864 17.3187C932.613 7.80254 952.407 3.04447 975.245 3.04447ZM1448.16 163.487C1448.16 172.242 1447.59 180.616 1446.45 188.61H1242.61C1244.51 216.397 1256.12 230.291 1277.44 230.291C1291.14 230.291 1301.04 224.01 1307.13 211.449H1441.31C1436.74 234.288 1427.04 254.843 1412.19 273.114C1397.73 291.004 1379.26 305.279 1356.81 315.937C1334.73 326.214 1310.37 331.353 1283.72 331.353C1251.75 331.353 1223.2 324.691 1198.08 311.369C1173.33 298.046 1153.92 279.014 1139.84 254.272C1126.13 229.149 1119.28 199.839 1119.28 166.342C1119.28 132.845 1126.13 103.726 1139.84 78.9836C1153.92 53.8609 1173.33 34.6382 1198.08 21.3155C1223.2 7.99287 1251.75 1.33154 1283.72 1.33154C1315.7 1.33154 1344.05 7.99287 1368.8 21.3155C1393.92 34.2575 1413.33 52.9092 1427.04 77.2707C1441.12 101.632 1448.16 130.371 1448.16 163.487ZM1319.69 133.226C1319.69 122.568 1316.27 114.574 1309.42 109.245C1302.56 103.535 1294 100.681 1283.72 100.681C1261.26 100.681 1248.13 111.529 1244.32 133.226H1319.69ZM1800 163.487C1800 172.242 1799.43 180.616 1798.29 188.61H1594.45C1596.35 216.397 1607.96 230.291 1629.28 230.291C1642.98 230.291 1652.88 224.01 1658.97 211.449H1793.15C1788.58 234.288 1778.87 254.843 1764.03 273.114C1749.56 291.004 1731.1 305.279 1708.64 315.937C1686.57 326.214 1662.21 331.353 1635.56 331.353C1603.59 331.353 1575.04 324.691 1549.91 311.369C1525.17 298.046 1505.76 279.014 1491.68 254.272C1477.97 229.149 1471.12 199.839 1471.12 166.342C1471.12 132.845 1477.97 103.726 1491.68 78.9836C1505.76 53.8609 1525.17 34.6382 1549.91 21.3155C1575.04 7.99287 1603.59 1.33154 1635.56 1.33154C1667.53 1.33154 1695.89 7.99287 1720.63 21.3155C1745.76 34.2575 1765.17 52.9092 1778.87 77.2707C1792.96 101.632 1800 130.371 1800 163.487ZM1671.53 133.226C1671.53 122.568 1668.11 114.574 1661.25 109.245C1654.4 103.535 1645.84 100.681 1635.56 100.681C1613.1 100.681 1599.97 111.529 1596.16 133.226H1671.53Z'
              strokeWidth={strokeWidth}
              stroke={svgFill || 'currentColor'}
              pathLength={pathLength}
              className={className}
            />
            <path
              fillRule='evenodd'
              d='M225.973 108.222C310.508 193.291 352.779 288.077 320.427 320.428C288.038 352.817 193.07 310.411 107.925 225.68C120.024 237.67 135.783 245.973 153.376 248.766C213.943 297.622 273.191 318.598 295.894 295.895C318.596 273.192 297.622 213.947 248.767 153.381C245.998 135.929 237.806 120.282 225.973 108.222ZM225.094 107.339C224.952 107.196 224.81 107.054 224.668 106.912C139.264 21.5079 43.6692 -21.3651 11.1515 11.1525C-21.3661 43.6702 21.5068 139.265 106.911 224.669C107.152 224.909 107.392 225.15 107.633 225.39C95.609 213.357 87.249 197.662 84.3699 180.122C34.4052 118.891 12.7424 58.629 35.685 35.6865C58.6271 12.7443 118.888 34.406 180.117 84.3689C197.516 87.2237 213.099 95.4713 225.094 107.339Z'
              clipRule='evenodd'
              strokeWidth={strokeWidth}
              stroke={svgFill || 'currentColor'}
              pathLength={pathLength}
              className={className}
            />
            <path
              d='M285 95C305 95 321 79 321 59 321 40 305 24 285 24 266 24 250 40 250 59 250 79 266 95 285 95ZM48 321C67 321 83 305 83 285 83 266 67 250 48 250 28 250 12 266 12 285 12 305 28 321 48 321Z'
              strokeWidth={strokeWidth}
              stroke={svgFill || 'currentColor'}
              pathLength={pathLength}
              className={className}
            />
            <path
              fillRule='evenodd'
              d='M166.533 333.067C258.507 333.067 333.067 258.507 333.067 166.533C333.067 74.5595 258.507 0 166.533 0C74.5595 0 0 74.5595 0 166.533C0 258.507 74.5595 333.067 166.533 333.067ZM166.533 249.8C212.52 249.8 249.8 212.52 249.8 166.533C249.8 120.546 212.52 83.2667 166.533 83.2667C120.546 83.2667 83.2666 120.546 83.2666 166.533C83.2666 212.52 120.546 249.8 166.533 249.8Z'
              clipRule='evenodd'
              strokeWidth={strokeWidth}
              stroke={svgFill || 'currentColor'}
              pathLength={pathLength}
              className={className}
            />
            <path
              d='M166.533 202.219C186.242 202.219 202.219 186.242 202.219 166.533C202.219 146.824 186.242 130.847 166.533 130.847C146.824 130.847 130.847 146.824 130.847 166.533C130.847 186.242 146.824 202.219 166.533 202.219Z'
              strokeWidth={strokeWidth}
              stroke={svgFill || 'currentColor'}
              pathLength={pathLength}
              className={className}
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='currentColor' d='M0 0H1800V334H0z' strokeWidth={strokeWidth} pathLength={pathLength} />
            </clipPath>
          </defs>
        </StyledLogo>
      </StyledLink>
    </div>
  )
}
